import { TopDestination } from '../types/wrapped'

export const AVERAGE_TRAVELLER_TEXT = '8 cities in 5 countries'
export const AVERAGE_TRAVELLED_DISTANCE_KM = 12392
export const AVERAGE_NIGHTS_AWAY = 57
export const AVERAGE_OFFERS_VIEWED = 450
export const AVERAGE_SAVINGS_PERCENTAGE = 28
export const AVERAGE_DESTINATIONS_SEARCHED = 13

// Top searched destinations for the year (used as fallback for low data users)
export const AVERAGE_TOP_DESTINATIONS: Array<TopDestination> = [
  { id: 'le_fc7c3c0a11d1db2c3f8e29ec9dd96c99', name: 'Bali', viewCount: 125000, imageId: 'vg4uvt2y5dgkivujuba6' },
  { id: 'le_2723d092b63885e0d7c260cc007e8b9d', name: 'Maldives', viewCount: 98000, imageId: 'dapbr82l65bcj5iy6v8' },
  { id: 'le_cf8b88a0c3bd5d1a6c1e1d3c0f2a4b6c', name: 'Paris', viewCount: 87000, imageId: 'dcou83bxqnsc1p49gii' },
]
